

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingRevenueTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accounting-revenue-transactions';
        this.Server =
            this.props.context.getState().server.accountingRevenueTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'systemAccountId',
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'accountingSystemAccounts',
                object: 'systemAccount',
                show: 'publicAddress'
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'comment',
                label: 'comment',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true,
                from: 'users',
                object: 'modifiedBy',
                show: 'email'
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                displayDialogDetails: true,
                details: 'Json',
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

